import { Grid, Stack, Text } from 'ui';
import { IconXTabler } from 'ui/Icons';

const NotAvailable = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 6 }} offset={{ base: 0, md: 3 }}>
        <Stack align="center" gap="lg">
          <IconXTabler width={64} height={64} color="#AAAAAA" brand="tabler" />
          <Stack align="center" gap="xs">
            <Text fz={24} fw={600} c="gray.8">
              Cause Not Available
            </Text>
            <Text fz={14} fw={400} c="gray.6" ta="center">
              This cause may no longer be available or the link is invalid. If you believe this is
              an error, please check the link or contact support.
            </Text>
          </Stack>
        </Stack>
      </Grid.Col>
    </Grid>
  );
};

export { NotAvailable };
